/*
 * @Author: your name
 * @Date: 2021-12-02 11:02:03
 * @LastEditTime: 2023-01-12 13:20:03
 * @LastEditors: 王溪
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pcweb-share\src\utils\request.js
 */
import axios from 'axios'
import { interceptorsResponse } from './interceptorsResponse';
import store from '@/store/index'
import {toastmes,userAgent,gtMessageCase} from '@/utils/utils'
import router from '@/router/index';
import {Message} from 'element-ui'
import {Cookies} from  '../utils/Cookies'
axios.defaults.timeout = 15000;//超时配置
const instance = axios.create({
  baseURL: process.env.BASE_URL

})
const isMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)
const request = function (params) {
  //pc端用el-loading,移动端用vant-loading
  let agent = userAgent()
  let loading
  if(!agent){
      loading = interceptorsResponse.loading()
  }else{
    store.commit('setLoadingText', '加载中...');
    store.commit('setShowLoading', true);
  }
    return new Promise((resolve, reject) => {
      instance(params)
        .then((response) => {
          if(!agent){
            loading.close()
          }else{
            store.commit('setShowLoading', false);
          }
          resolve(response.data);
        })
        .catch(function (error) {
          if(!agent){
            loading.close()
          }else{
            store.commit('setShowLoading', false);
          }
          reject(error);
        });
    })
  }

const post = function (url, data, params, options) {
    return request({
        method: 'post',
        withCredentials: true,
        url,
        data,
        params,
        ...options,
    })
}

const get = function (url, data, params, options) {
    return request({
        method: 'get',
        withCredentials: true,
        url,
        data,
        params,
        ...options,

    })
}

  // 请求拦截器
  instance.interceptors.request.use((config) => {
    // console.log(config)
    if (config.needToken) {
      config.params.accessToken =Cookies.get('ak') || config.data.ak
    }

    if (config.needPage) {
      config.params.page = 1
    }
    if (config.needLimit) {
      config.params.limit = 50
    }
    if (config.needShareKey) {
      config.data.shareKey = Cookies.get('shareKey') //获取store里面的数据
    }
    if(!config.params.needCredentials){
      config.withCredentials = false
    }

    return config;
    },
    (error) => {
      Promise.reject(error);
  })

  instance.interceptors.response.use((response) => {
    const res = response.data
    let agent = userAgent() 
    let excludeerror=[41054,10003,42001,41060]  //需要外放业务处理的错误码
     let errorCode='error_code' in res ?res.error_code:'code' in res?res.code:'-1'
     errorCode = !!store.getters['errorData'][errorCode]? errorCode : '-1'
       if (errorCode&& store.getters['errorData'][errorCode] && !response.config.noToast&& !excludeerror.includes(Number(errorCode)) )  {
         switch (errorCode) {
          case 28012:
          case 28015:
        
              store.commit('setFilterWrap', false)
              Cookies.remove('ak')
              if (agent) {
                setTimeout(() => {

                  router.push({
                    name: 'login',
                     query:{opertion:router.history.current.name}
                  });
               }, 1000);
              }else{
                gtMessageCase.error('云账号信息已过期')
              
              }
            
            
            break;
          case 41050:
          case 41051:
            router.push({
              name: "notfound",
            
            });
          
            
          default:
            let msg = errorCode == '-1' ? `${store.getters['errorData'][errorCode].err_msg_cn}:${res.error_code}`:`${store.getters['errorData'][errorCode].err_msg_cn}`
            if (agent) {
              if (msg !== '分享失效') {
                toastmes(msg, 'fail')
              }
            }else{
          
              gtMessageCase.error( msg)
            
            }
            return response;
  
  
        }
       } 
       
       
       else if (!response.config.noToast) {
   
       }
     

    return response;
    },
    (error) => {
      if (error.response) {
        let res = error.response;
        if(res.status==401){
          Cookies.remove('ak')
          store.commit('setLoginFlag', false) //登录已经过期
          if (isMobile) {
            toastmes('账号登录信息已过期', 'fail')
            router.push({name:'login'})
          }
        }
        return res
      }else{
        // let loading = interceptorsResponse.loading();
        // loading.close();
      }

      Promise.reject(error);
  })



export {
    post,
    get
}


// WEBPACK FOOTER //
// ./src/utils/request.js